import { getTranslatedFormText } from "features/shared/helpers/translationHelper";
import IKeyValuePair from "features/shared/models/IKeyValuePair";
import React from "react";
import { useTranslation } from "react-i18next";
import SelectInput from "../../selectInput/SelectInput";
import IDataFilterEnumValue from "../enumCheckBox/IDataFilterEnumValue";
import IDataFilterDescriptor from "../IDataFilterDescriptor";
import IDataFilterProps from "../IDataFilterProps";

const DataFilterEnumSelectInputBox = (props: IDataFilterProps) => {
  // translations
  const tLables = useTranslation("shared\\dataFilters").t;
  const { t } = useTranslation([
    props.filterDescriptor.valueTranslationPath || "",
  ]);

  const setDescriptorValue = (enumName: string, enumKey: string) => {
    const newDescriptors = [...props.descriptors];

    // Získám descriptor
    const descriptor = newDescriptors.find((x) => x.name === enumName);
    if (!descriptor) return;

    // Původní hodnotu nastavím na false
    resetOldValue(descriptor);

    // Získám aktuální hodnotu z descriptoru
    const value = (descriptor.value as IDataFilterEnumValue[]).find(
      (x) => x.key === enumKey
    );

    // Nastavím hodnotu
    if (value) {
      value.value = true;
    } else {
      // Pokud nenajdu, vytvořím novou
      (descriptor.value as IDataFilterEnumValue[]).push({
        key: enumKey,
        value: true,
      });
    }

    // Update
    props.setDescriptors(newDescriptors);
  };

  const getOptionsData = (): any[] => {
    let selectInputData: IKeyValuePair<string, string>[] = [];

    const enumValues = props.filterDescriptor.value as IDataFilterEnumValue[];
    if (enumValues && enumValues.length > 0) {
      enumValues.forEach((enumValue) => {
        if (!enumValue.hidden) {
          selectInputData.push({
            key: enumValue.key,
            value: t(enumValue.key),
          });
        }
      });
    }

    return selectInputData;
  };

  const getSelectedValue = (): string => {
    return (
      (props.filterDescriptor.value as IDataFilterEnumValue[]).find(
        (x) => x.value
      )?.key ?? ""
    );
  };

  const setDefaultDescriptor = (enumName: string) => {
    const newDescriptors = [...props.descriptors];

    // Získám descriptor
    const descriptor = newDescriptors.find((x) => x.name === enumName);
    if (!descriptor) return;

    // Původní hodnotu nastavím na false
    resetOldValue(descriptor);

    // Update
    props.setDescriptors(newDescriptors);
  };

  const handleOnChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const enumKey = event.target.value;
    const enumName = event.target.name;

    if (!enumKey) {
      setDefaultDescriptor(enumName);
    } else {
      setDescriptorValue(event.target.name, event.target.value);
    }
  };

  const resetOldValue = (descriptor: IDataFilterDescriptor) => {
    const oldValue = (descriptor.value as IDataFilterEnumValue[]).find(
      (x) => x.value
    );
    if (oldValue) oldValue.value = false;
  };

  return (
    <SelectInput
      reactKey={props.reactKey}
      name={props.filterDescriptor.name}
      label={getTranslatedFormText(props.filterDescriptor, "label", tLables)}
      defaultValueLabel={getTranslatedFormText(props.filterDescriptor, "placeholder", tLables)}
      value={getSelectedValue()}
      options={getOptionsData()}
      optionName={"value"}
      optionValue={"key"}
      onChange={handleOnChange}
    />
  );
};

export default DataFilterEnumSelectInputBox;
